import React from "react";
import { Route, Redirect } from "react-router-dom";
import AlertModalCommon from "../common/components/AlertModalCommon";

function PrivateRoute({ component: Component, ...rest }) {
  const isAuthenticated =
    localStorage.getItem("user") &&
    localStorage.getItem("exp") > new Date().getTime() / 1000;

  return (
    <Route
      {...rest}
      render={({ location }) =>
        isAuthenticated ? (
          <>
            <Component />
            <AlertModalCommon />
          </>
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: location },
            }}
          />
        )
      }
    />
  );
}

export default PrivateRoute;